import { Vue, Component } from 'vue-property-decorator';
@Component
export default class NoteEdit extends Vue {
  pointerMove: Function;
  pointerDown: Function;
  pointerUp: Function;
  touchStart: Function;
  touchMove: Function;
  touchEnd: Function;
  moving = false;
  startPoint:
    | undefined
    | {
        pageX: number;
        pageY: number;
      } = undefined;

  position = {
    top: 0,
    left: 0
  };

  onPointerDown(e: MouseEvent | TouchEvent) {
    this.$emit('clickNote');
    const page = this.getPagePosition(e);
    if (!page) return;
    this.moving = true;
    this.startPoint = {
      pageX: page.x,
      pageY: page.y
    };
  }

  onPointerUp(e: MouseEvent | TouchEvent) {
    this.moving = false;
    this.startPoint = undefined;
  }

  onPointerMove(e: MouseEvent | TouchEvent) {
    // e.preventDefault();
    // e.stopPropagation();
    if (!this.moving) return;
    const page = this.getPagePosition(e);
    if (!page) return;
    let deltaX = 0;
    let deltaY = 0;
    if (this.startPoint) {
      deltaX = page.x - this.startPoint.pageX || 0;
      deltaY = page.y - this.startPoint.pageY || 0;
    }

    this.move(deltaX, deltaY);
    this.startPoint = {
      pageX: page.x,
      pageY: page.y
    };
  }

  move(offsetX: number, offsetY: number) {
    if (this.isNumber(offsetX)) {
      this.position.left = this.position.left + offsetX;
    }

    if (this.isNumber(offsetY)) {
      this.position.top = this.position.top + offsetY;
    }
  }

  getPagePosition(e: MouseEvent | TouchEvent): { x: number; y: number } | undefined {
    const position = {
      x: 0,
      y: 0
    };
    if (e instanceof TouchEvent) {
      if (e.changedTouches.length > 1) return;
      position.x = e.changedTouches[0].pageX;
      position.y = e.changedTouches[0].pageY;
    } else {
      position.x = e.pageX;
      position.y = e.pageY;
    }
    return position;
  }

  isNumber(arg: any) {
    return typeof arg === 'number' && !isNaN(arg);
  }

  bindEvents() {
    this.$nextTick(() => {
      const el = this.$refs.title as HTMLDivElement;
      el?.addEventListener('mousedown', (this.pointerDown = this.onPointerDown.bind(this)));
      el?.addEventListener('touchstart', (this.touchStart = this.onPointerDown.bind(this)));
      document?.addEventListener('mousemove', (this.pointerMove = this.onPointerMove.bind(this)));
      document?.addEventListener('touchmove', (this.touchMove = this.onPointerMove.bind(this)));
      document.addEventListener('mouseup', (this.pointerUp = this.onPointerUp.bind(this)));
      document.addEventListener('touchend', (this.touchEnd = this.onPointerUp.bind(this)));
    });
  }
  initPosition() {
    this.$nextTick(() => {
      const el = this.$refs.wrapper as HTMLDivElement;
      const viewerWidth = window.innerWidth;
      const viewerHeight = window.innerHeight;
      this.position.top = (viewerHeight - el.clientHeight) / 2;
      this.position.left = (viewerWidth - el.clientWidth) / 2;
    });
  }
}
